<template>
<div>
  <v-menu data-trust="created-date"
      :close-on-content-click="false"
      v-model="showTrustDate"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
      >
      <v-text-field
        slot="activator"
        v-model="trust.created"
        label="Trust creation date"
        prepend-icon="event"
        readonly
        ></v-text-field>
      <v-date-picker v-model="trust.created" @input="showTrustDate = false">
      </v-date-picker>
  </v-menu>
  <v-menu data-flight="date-menu"
      :close-on-content-click="false"
      v-model="showFlightDate"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
      >
      <v-text-field
        slot="activator"
        v-model="flight.date"
        label="First international flight"
        prepend-icon="event"
        readonly
        ></v-text-field>
      <v-date-picker data-flight="date-picker" v-model="flight.date" @input="showFlightDate = false">
      </v-date-picker>
  </v-menu>
  <v-text-field data-flight="departure"
      v-model="flight.departure" 
      label="International flight departure" 
      required>
  </v-text-field>
  <v-text-field data-flight="destination"
      v-model="flight.destination" 
      label="International flight destination" 
      required>
  </v-text-field>
</div>
</template>

<script>
export default {
  data: () => ({
    showTrustDate: false,
    showFlightDate: false
  }),
  props: ["trust", "flight"],
  computed: {},
  methods: {}
};
</script>

<style>
</style>
